import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';

const gitopsServiceField = FormFieldBlueprint.make({
  name: 'gitops-service-picker',
  params: {
    field: async () => {
      const m = await import('./GitopsServicePicker');
      return m.GitopsServicePicker;
    },
  },
});

const gitopsServicesField = FormFieldBlueprint.make({
  name: 'gitops-services-picker',
  params: {
    field: async () => {
      const m = await import('./GitopsServicesPicker');
      return m.GitopsServicesPicker;
    },
  },
});

const promoteEnvironmentField = FormFieldBlueprint.make({
  name: 'promote-environment-picker',
  params: {
    field: async () => {
      const m = await import('./PromoteEnvironmentPicker');
      return m.PromoteEnvironmentPicker;
    },
  },
});

const gitopsResourceConfigField = FormFieldBlueprint.make({
  name: 'gitops-resource-config-picker',
  params: {
    field: async () => {
      const m = await import('./GitopsResourceConfigPicker');
      return m.GitopsResourceConfigPicker;
    },
  },
});

const gitopsEnvConfigField = FormFieldBlueprint.make({
  name: 'gitops-env-config-picker',
  params: {
    field: async () =>
      (await import('./GitopsEnvConfigPicker')).GitopsEnvConfigPicker,
  },
});

const gitopsSecretRefField = FormFieldBlueprint.make({
  name: 'gitops-secret-ref-picker',
  params: {
    field: async () =>
      (await import('./GitopsSecretRefPicker')).GitopsSecretRefPicker,
  },
});

const excludeServicesField = FormFieldBlueprint.make({
  name: 'exclude-services-picker',
  params: {
    field: async () =>
      (await import('./ExcludeServicesPicker')).ExcludeServicesPicker,
  },
});

const ticketRefsField = FormFieldBlueprint.make({
  name: 'ticket-refs-picker',
  params: {
    field: async () => (await import('./TicketRefsPicker')).TicketRefsPicker,
  },
});

const usvcMigrationBranchField = FormFieldBlueprint.make({
  name: 'UsvcMigrationBranchPicker',
  params: {
    field: async () =>
      (await import('./UsvcMigrationBranchPicker')).UsvcMigrationBranchPicker,
  },
});

const onDemandMigrationField = FormFieldBlueprint.make({
  name: 'OnDemandMigrationPicker',
  params: {
    field: async () =>
      (await import('./OnDemandMigrationPicker')).OnDemandMigrationPicker,
  },
});

const sharedActionsVersionField = FormFieldBlueprint.make({
  name: 'SharedActionsVersionPicker',
  params: {
    field: async () =>
      (await import('./SharedActionsVersionPicker')).SharedActionsVersionPicker,
  },
});

const githubRepoNameField = FormFieldBlueprint.make({
  name: 'GithubRepoNamePicker',
  params: {
    field: async () =>
      (await import('./GithubRepoNamePicker')).GithubRepoNamePicker,
  },
});

const githubRepoPropertiesField = FormFieldBlueprint.make({
  name: 'GithubRepoPropertiesPicker',
  params: {
    field: async () =>
      (await import('./GithubRepoPropertiesPicker')).GithubRepoPropertiesPicker,
  },
});

/**
 * Contributes the custom Scaffolder field extensions used by the self-service
 * templates (Promote code). Attaches to the scaffolder plugin so its form
 * picks them up; reference them in templates via `ui:field`.
 */
export const templatesModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    gitopsServiceField,
    gitopsServicesField,
    promoteEnvironmentField,
    gitopsResourceConfigField,
    gitopsEnvConfigField,
    gitopsSecretRefField,
    excludeServicesField,
    ticketRefsField,
    usvcMigrationBranchField,
    onDemandMigrationField,
    sharedActionsVersionField,
    githubRepoNameField,
    githubRepoPropertiesField,
  ],
});
